(function($) {
  "use strict";

  jQuery(document).ready(function(){

    // preloader
    /*
    $(window).on('load', function() {
      $('#preloader_active').fadeOut('slow');
    });
    */



    /*--------------------------
    1. Newsletter Popup
    ---------------------------*/
    setTimeout(function () {
      $('.popup_wrapper').css({
        "opacity": "1",
        "visibility": "visible"
      });
      $('.popup_off').on('click', function () {
        $(".popup_wrapper").fadeOut(500);
      })
    }, 2500);

    /*----------------------------
    2. Mobile Menu Activation
    -----------------------------*/
    jQuery('.mobile-menu nav').meanmenu({
      meanScreenWidth: "991",
    });

    /*----------------------------
    3 Checkout Page Activation
    -----------------------------*/
    $('.categorie-title').on('click', function () {
      $('.vertical-menu-list').slideToggle();
    });

    $('#showlogin').on('click', function () {
      $('#checkout-login').slideToggle();
    });
    $('#showcoupon').on('click', function () {
      $('#checkout_coupon').slideToggle();
    });
    $('#cbox').on('click', function () {
      $('#cbox_info').slideToggle();
    });
    $('#ship-box').on('click', function () {
      $('#ship-box-info').slideToggle();
    });


    /*----------------------------
    13. WOW Js Activation
    -----------------------------*/
    new WOW().init();

    /*----------------------------
    14. ScrollUp Activation
    -----------------------------*/
    $.scrollUp({
      scrollName: 'scrollUp', // Element ID
      topDistance: '550', // Distance from top before showing element (px)
      topSpeed: 1000, // Speed back to top (ms)
      animation: 'fade', // Fade, slide, none
      scrollSpeed: 900,
      animationInSpeed: 1000, // Animation in speed (ms)
      animationOutSpeed: 1000, // Animation out speed (ms)
      scrollText: '<i class="fa fa-angle-up"></i>', // Text for element
      activeOverlay: false // Set CSS color to display scrollUp active point, e.g '#00FFFF'
    });

    /*----------------------------
    15. Sticky-Menu Activation
    ------------------------------ */
    $(window).scroll(function () {
      if ($(this).scrollTop() > 150) {
        $('.header-sticky').addClass("sticky");
      } else {
        $('.header-sticky').removeClass("sticky");
      }
    });

    /*----------------------------
    16. Price Slider Activation
    -----------------------------*/
    $("#slider-range").slider({
      range: true,
      min: 0,
      max: 80,
      values: [0, 74],
      slide: function (event, ui) {
        $("#amount").val("$" + ui.values[0] + "  $" + ui.values[1]);
      }
    });
    $("#amount").val("$" + $("#slider-range").slider("values", 0) +
                     "  $" + $("#slider-range").slider("values", 1));


    /*----------------------------------------------------
    19. Best Product Activation
    -----------------------------------------------------*/
    $('.best-seller-pro-two')
    .owlCarousel({
      loop: false,
      nav: false,
      dots: false,
      smartSpeed: 1200,
      margin: 0,
      responsive: {
        0: {
          items: 1,
          autoplay:true
        },
        768: {
          items: 3
        },
        1000: {
          items: 1
        }
      }
    })

    /*-------------------------------------
    20. Blog Realted Post activation
    --------------------------------------*/
    $('.blog-related-post-active').owlCarousel({
      loop: false,
      margin: 30,
      smartSpeed: 1000,
      nav: false,
      dots: false,
      items: 2,
      responsive: {
        0: {
          items: 1,
          autoplay:true
        },
        480: {
          items: 1
        },
        768: {
          items: 2
        },
        992:{
          margin: 29,
          items: 2
        },
        1200: {
          items: 2
        }
      }
    })

    /*----------------------------------------------------
    21.Best Seller  Unique Activation
    -----------------------------------------------------*/
    $('.best-seller-unique').on('changed.owl.carousel initialized.owl.carousel', function (event) {
      $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
    }).owlCarousel({
      loop: false,
      nav: true,
      dots: false,
      smartSpeed: 1000,
      navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
      margin: 0,
      responsive: {
        0: {
          items: 1,
          autoplay:true
        },
        768: {
          items: 2
        },
        1000: {
          items: 1
        }
      }
    })

    $(".brand-banner").owlCarousel({loop:!1,nav:!1,dots:!1,smartSpeed:1200,margin:30,responsive:{0:{items:1,autoplay:!0},480:{items:3},768:{items:4},1e3:{items:5}}});
    $(".new-upsell-pro").owlCarousel({loop:!1,nav:!0,dots:!1,smartSpeed:1e3,navText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],margin:30,responsive:{0:{items:1,autoplay:!0},480:{items:1},768:{items:2},1e3:{items:3},1200:{items:4}}});



    // Ajax Wishlist
    $(".cart-item").on('click', function(){
      $(this).addClass("loading add-item");
      setTimeout(function () {
        $(".cart-item").removeClass("loading");
      },1000);
      setTimeout(function () {
        $(".cart-item").removeClass("add-item");
      },1800);

    });

    // Remove Hyperlink
    $(".remove_href").removeAttr("href");


    $(".prod_price span:first-child").addClass("price");
    $(".prod_price span:nth-child(2)").addClass("prev-price");



  // Currency
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm); 


  });

})(jQuery);